import React from "react";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Button, ListItem } from '@mui/material';
import { styled } from "@mui/system";

const StyledDashboard = styled("Box")(({ theme }) => ({
  "& .item": {
    display: "block",
    paddingTop: 0,
    paddingBottom: 0,
  },
  "& .itemLeaf": {
    padding: "unset",
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  "& .icon": {
    display: "flex",
    alignItems: "center",
    marginRight: "10px",
    marginLeft: theme.spacing(1),
    color: "#fff",
  },
  "& .title": {
    marginRight: "auto",
  },
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  ...rest
}) => {
  let paddingLeft = 25;
  if (depth > 0) {
    paddingLeft = 32 + 15 * depth;
  }
  const style = { paddingLeft };
  return (
    <StyledDashboard >
      <ListItem
        className="itemLeaf"
        type="button"
        disableGutters
        key={title}
        {...rest}
      >
        <NavLink
          exact
          to={href}
          className={({ isActive }) => clsx("buttonLeaf", `depth-${depth}`, { active: isActive })}
        >
          <Button
            className={clsx("buttonLeaf", `depth-${depth}`)}
            style={style}
          >
            {Icon && <Icon className="icon" size="20" />}
            <span className="title">{title}</span>
            {Info && <Info />}
          </Button>
        </NavLink>
      </ListItem>
    </StyledDashboard >
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  open: false,
};

export default NavItem;
